import * as THREE from "three";
import RAPIER from "@dimforge/rapier3d-compat";

import { HangingRig } from "../../../entities/hanging_rig.js";
import { HangConfig, PhysicsTable } from "../../../entities/physics_table.js";
import { PhysicsWorld } from "../../../physics/physics_world.js";
import { RigidMotion } from "../../../physics/physics_protocol.js";

const AXIS = new THREE.Vector3( 0, 0, 1 );
const TMP_Q_DELTA = new THREE.Quaternion();
const MOVED: RAPIER.RigidBody[] = [];
const MOTION: RigidMotion = { rotate: true, planar: false, px: 0, py: 0, pz: 0, qx: 0, qy: 0, qz: 0, qw: 1, dx: 0, dy: 0, dz: 0 };

export class TableSwinger
{
  private time = 0;
  private angle = 0;

  constructor(
    private readonly rig: HangingRig,
    private readonly config: HangConfig,
    private readonly get_bodies: ( table: PhysicsTable ) => Iterable<RAPIER.RigidBody>
  )
  {}

  public step( dt: number ): void
  {
    this.time += dt;

    const period = Math.max( this.config.swingPeriodSec, 0.1 );
    const swing_rad = this.config.swingDeg * Math.PI / 180;
    const next_angle = swing_rad * Math.sin( this.time * ( 2 * Math.PI / period ) );

    const delta = next_angle - this.angle;
    this.angle = next_angle;

    if ( delta !== 0 )
      this.applyDelta( delta );

    this.rig.setAngle( this.angle );
  }

  private applyDelta( delta: number ): void
  {
    const pivot = this.rig.getPivotWorld();

    TMP_Q_DELTA.setFromAxisAngle( AXIS, -delta );

    MOVED.length = 0;
    for ( const table of this.rig.getTables() )
      for ( const body of this.get_bodies( table ) )
      {
        if ( !body.isValid() )
          continue;

        if ( table.isOutside( body.translation() ) )
          continue;

        MOVED.push( body );
      }

    MOTION.px = pivot.x; MOTION.py = pivot.y; MOTION.pz = pivot.z;
    MOTION.qx = TMP_Q_DELTA.x; MOTION.qy = TMP_Q_DELTA.y; MOTION.qz = TMP_Q_DELTA.z; MOTION.qw = TMP_Q_DELTA.w;
    PhysicsWorld.moveBodies( MOVED, MOTION );
    MOVED.length = 0;
  }
}
